import React from "react";
import { View, ViewStyle } from "react-native";
import { DividerProps } from "@xsolla/xui-primitives-core";

export const Divider: React.FC<DividerProps> = ({
  color,
  height,
  width,
  vertical,
  dashStroke,
  testID,
  "data-testid": dataTestId,
}) => {
  const style: ViewStyle = {
    backgroundColor: dashStroke
      ? "transparent"
      : color || "rgba(255, 255, 255, 0.15)",
    width: vertical ? (typeof width === "number" ? width : 1) : "100%",
    height: vertical ? "100%" : typeof height === "number" ? height : 1,
    ...(dashStroke && {
      borderStyle: "dashed",
      borderColor: color || "rgba(255, 255, 255, 0.15)",
      borderWidth: 0,
      ...(vertical
        ? { borderLeftWidth: typeof width === "number" ? width : 1 }
        : { borderTopWidth: typeof height === "number" ? height : 1 }),
    }),
  };

  return <View style={style} testID={dataTestId || testID} />;
};
